/** Weight / layer stepper — matches froster production task UI. */
import {
  bumpCalculatorWeight,
  formatCalculatorWeight,
} from "@/lib/calculatorWeight";

export default function CalculatorStepper({
  value,
  onChange,
  min,
  max,
  step = 1,
  decimals = 0,
  calculatorWeight = false,
}) {
  const num = Number(value);
  const current = Number.isFinite(num) ? num : min;

  const format = (n) => {
    if (calculatorWeight) return formatCalculatorWeight(n);
    if (decimals > 0) return String(Math.round(n * 100) / 100);
    return String(Math.round(n));
  };

  const bump = (direction) => {
    let next;
    if (calculatorWeight) {
      next = bumpCalculatorWeight(current, direction);
    } else {
      next = current + direction * step;
      next = Math.round(next / step) * step;
      next = Math.max(min, Math.min(max, next));
    }
    onChange(format(next));
  };

  return (
    <div className="driver-frost-stepper">
      <button
        type="button"
        className="driver-frost-stepper-btn"
        onClick={() => bump(-1)}
        aria-label="Decrease"
      >
        −
      </button>
      <input
        type="text"
        inputMode={decimals > 0 || calculatorWeight ? "decimal" : "numeric"}
        className="driver-frost-stepper-value"
        value={value}
        readOnly
        aria-readonly="true"
      />
      <button
        type="button"
        className="driver-frost-stepper-btn driver-frost-stepper-btn--plus"
        onClick={() => bump(1)}
        aria-label="Increase"
      >
        +
      </button>
    </div>
  );
}
